var map = {
	"./1.svg": "e589",
	"./1g.svg": "5cb1",
	"./2.svg": "61be",
	"./2g.svg": "e19b",
	"./3.svg": "dcc2",
	"./3g.svg": "35ee",
	"./4.svg": "9897",
	"./42.svg": "0c11",
	"./4g.svg": "c16a",
	"./4g2.svg": "4867",
	"./5.svg": "20e9",
	"./5g.svg": "eb99",
	"./6.svg": "e22f",
	"./6g.svg": "189f",
	"./7.svg": "006a",
	"./7g.svg": "ac2f",
	"./Group 2896.svg": "3e7b",
	"./Mask Group 127.svg": "d684",
	"./Mask Group 130 - w.svg": "fe17",
	"./Mask Group 130.svg": "a7dc",
	"./Mask Group 131.svg": "f968",
	"./Mask Group 132.svg": "6e81",
	"./Mask Group 139.svg": "d521",
	"./Mask Group 140 (1).svg": "4533",
	"./Mask Group 140.svg": "55fd",
	"./Mask Group 156.svg": "8e94",
	"./Mask Group 159.svg": "49c6",
	"./Mask Group 164.svg": "137a",
	"./Mask Group 182.svg": "3530",
	"./Mask Group 94.svg": "2d27",
	"./Mask Group down(1).svg": "dc6e",
	"./Mask Group up.svg": "1527",
	"./Profile.svg": "afda",
	"./ThaiFlag.svg": "64bf",
	"./UkFlag.svg": "bc9f",
	"./aaaa.svg": "1acd",
	"./library_article.svg": "ba0d",
	"./library_sound.svg": "6487",
	"./library_video.svg": "53d3",
	"./maintenance_bg.svg": "7968",
	"./yellow_alert.svg": "8e0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edbe";